module.exports = __webpack_public_path__ + "img/match.f7f9bbaa.svg";